/**
 * Market switcher.
 *
 * The options are plain links to the two market URLs, so navigation needs no
 * JavaScript. This only opens and closes the list.
 */

function closeAll(except) {
  document.querySelectorAll('market-switcher[open-list]').forEach((node) => {
    if (node === except) return;
    node.removeAttribute('open-list');
    node.querySelector('[data-market-toggle]')?.setAttribute('aria-expanded', 'false');
    node.querySelector('.market-switcher__list')?.setAttribute('hidden', '');
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-market-toggle]');

  if (toggle) {
    event.preventDefault();
    const switcher = toggle.closest('market-switcher');
    const list = switcher?.querySelector('.market-switcher__list');
    if (!switcher || !list) return;

    const isOpen = switcher.hasAttribute('open-list');
    closeAll(switcher);

    switcher.toggleAttribute('open-list', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
    list.toggleAttribute('hidden', isOpen);
    return;
  }

  if (!event.target.closest('market-switcher')) closeAll(null);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeAll(null);
});
